import { SlideDataType } from '@sportworld/js-sdk/src/types/sliderTypes'

export const createProgressiveGrid = (
  swiper: any,
  slidesOffsetBefore: number,
  spaceBetween: number,
  slidesOffsetAfter: number,
  setSnapGridPrev: (snapGridPrev: Array<number>) => void,
  setSnapGridNext: (snapGridNext: Array<number>) => void,
) => {
  swiper.wrapperEl.style.transform = `translate3d(${slidesOffsetBefore}px, 0px, 0px)`
  swiper.snapGrid = swiper.slidesGrid
  const slideWidth = swiper.slidesSizesGrid[0]
  const shiftWidth =
    (swiper.virtualSize + slidesOffsetAfter - swiper.size) /
    (swiper.slidesSizesGrid.length - 1)
  const sliderWidth =
    (slideWidth + spaceBetween) * swiper.slidesSizesGrid.length +
    slidesOffsetAfter
  const snapGrid = swiper.slidesSizesGrid.map((snap: unknown, i: number) =>
    sliderWidth <= swiper.size
      ? slidesOffsetBefore
      : -Math.floor(shiftWidth * i) + slidesOffsetBefore,
  )
  setSnapGridPrev(snapGrid)
  setSnapGridNext(snapGrid)
  return { snapGridNext: snapGrid, snapGridPrev: snapGrid }
}

export const createPushGrid = (
  swiper: any,
  slidesOffsetBefore: number,
  slidesOffsetAfter: number,
  setSnapGridNext: (snapGridNext: Array<number>) => void,
  setSnapGridPrev: (snapGridPrev: Array<number>) => void,
) => {
  swiper.wrapperEl.style.transform = `translate3d(${slidesOffsetBefore}px, 0px, 0px)`
  swiper.snapGrid = swiper.slidesGrid
  const slideWidth = swiper.slidesSizesGrid[0]
  const beforeSlidesPerView = Math.floor(
    (swiper.width - slidesOffsetBefore) / slideWidth,
  )
  const afterSlidesPerView = Math.floor(
    (swiper.width - slidesOffsetAfter) / slideWidth,
  )
  const snapGridNext = swiper.slidesGrid.map((el: any, i: number) =>
    i < beforeSlidesPerView
      ? slidesOffsetBefore
      : i === swiper.slidesGrid.length - 1
      ? slidesOffsetBefore -
        slideWidth * swiper.slidesGrid.length +
        swiper.size -
        slidesOffsetAfter
      : slidesOffsetBefore - slideWidth * (i - (beforeSlidesPerView - 1)),
  )
  setSnapGridNext(snapGridNext)
  const slidesPerView = Math.floor(
    (swiper.width - slidesOffsetAfter - slidesOffsetBefore) / slideWidth,
  )
  const snapGridPrev = swiper.slidesGrid.map((el: any, i: number) =>
    swiper.slidesGrid.length <= slidesPerView
      ? slidesOffsetBefore
      : i < swiper.slidesGrid.length - afterSlidesPerView
      ? slidesOffsetBefore - slideWidth * i
      : slidesOffsetBefore -
        slideWidth * swiper.slidesGrid.length +
        swiper.size -
        slidesOffsetAfter,
  )
  setSnapGridPrev(snapGridPrev)

  return { snapGridNext, snapGridPrev }
}

export const getActiveSlideIndex = (
  sliderData: SlideDataType[],
  activeSlideId?: string,
) => {
  let activeIndex = 0
  if (activeSlideId) {
    activeIndex = sliderData.findIndex((item) => activeSlideId === item.id)
  }
  return Math.max(activeIndex, 0)
}
